mutation currentUserPasswordChange($currentPassword: String!, $newPassword: String!) {
  currentUserPasswordChange(currentPassword: $currentPassword, newPassword: $newPassword) {
    id
    first
    last
    email
  }
}
